"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _reactAddonsPureRenderMixin = _interopRequireDefault(require("react-addons-pure-render-mixin"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _Functions = require("../core/Functions");

var _TabIndex = require("../utils/TabIndex");

var _default = _react.default.createClass({
  displayName: "UIUnstyledButton",
  mixins: [_reactAddonsPureRenderMixin.default],
  propTypes: {
    disabled: _react.PropTypes.bool,
    type: _react.PropTypes.oneOf(['button', 'reset', 'submit']).isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {
      type: 'button'
    };
  },
  handleMouseDown: function handleMouseDown(evt) {
    var onMouseDown = this.props.onMouseDown;

    if (this.props.disabled) {
      evt.stopPropagation();
    }

    (0, _Functions.callIfPossible)(onMouseDown, evt);
  },
  handleClick: function handleClick(evt) {
    var onClick = this.props.onClick;

    if (this.props.disabled) {
      evt.preventDefault();
      evt.stopPropagation();
    } else {
      (0, _Functions.callIfPossible)(onClick, evt);
    }
  },
  render: function render() {
    var _this$props = this.props,
        className = _this$props.className,
        disabled = _this$props.disabled,
        __onClick = _this$props.onClick,
        __onMouseDown = _this$props.onMouseDown,
        tabIndex = _this$props.tabIndex,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["className", "disabled", "onClick", "onMouseDown", "tabIndex"]);
    return _react.default.createElement("button", (0, _extends2.default)({}, rest, {
      "aria-disabled": disabled,
      className: (0, _classNames.default)('private-button--unstyled', className),
      onClick: this.handleClick,
      onMouseDown: this.handleMouseDown,
      tabIndex: (0, _TabIndex.getTabIndex)(disabled, tabIndex)
    }));
  }
});

exports.default = _default;
module.exports = exports.default;